





















































import { defineComponent, ref, computed, useRouter } from '@nuxtjs/composition-api'

// Components
import IconFa6SolidXmark from '~icons/fa6-solid/xmark'

// Stores
import { useCompareProductsStore } from '~/store'

// Types
import { ImageEnhancementConfigInterface } from '~/types/image-enhancement/imageEnhancementTypes'
import { getDisplayNameForApplicationCode } from '~/common/utils/parsing'

export default defineComponent({
  name: 'ImageEnhancementHeader',

  components: {
    IconFa6SolidXmark,
  },

  props: {
    config: {
      type: Object as () => ImageEnhancementConfigInterface,
      required: true,
    },
  },

  emits: ['onImageEnhancementChangeApplication'],

  setup(props) {
    const selectedApplicationCode = ref(props.config.application.activeApplication)
    const compareStore = useCompareProductsStore()
    const applications = props.config.productdata?.attributes.lots?.lot.applications?.application
    const hasApplications = computed(() => Object.keys(props.config.application.groupsAndCodes).length > 0)
    const router = useRouter()

    const close = () => {
      if (props.config.productdata) {
        // If signalstar, return to step 2
        if (props.config.type === 'signalstar') {
          router.push('/products/signalstar/selectantibodies')
          return
        }

        // If PCP, return to PCP
        if (props.config.type === 'pcp') {
          window.location.href = compareStore.getCompareProductsUrl
          return
        }

        // else go to PDP
        const index = props.config.currentSlide + 1
        if (props.config.application.activeApplication !== 'additional data') {
          const applicationGroup =
            props.config.application.activeApplication === 'all'
              ? props.config.application.activeApplication
              : props.config.application.selectedApplication![0].group

          const normalizedApplicationGroup = getDisplayNameForApplicationCode(applicationGroup)

          if (normalizedApplicationGroup) {
            router.push(
              `/products/${props.config.productdata.key}?index=${index}&application=${encodeURIComponent(
                normalizedApplicationGroup
              )}`
            )
          }
        } else {
          router.push(`/products/${props.config.productdata.key}?index=${index}`)
        }
      }
    }

    const getTitle = () => {
      // If a user is coming from the panel builder, show the clicked targetName instead of the product name and ID
      if (props.config.type === 'signalstar' && props.config.targetName.length > 0) {
        return props.config.targetName
      }

      return props.config.productdata
        ? props.config.productdata.name['en-US' as any] + ' #' + props.config.productdata.key
        : 'No product data available'
    }

    return {
      close,
      getTitle,
      applications,
      selectedApplicationCode,
      hasApplications,
    }
  },
})
